import {css} from 'emotion'
import { Colors, Easings } from '../'

export const FilterStyle = (open, dark) => css({
  justifyContent: 'flex-end',
  position: 'relative',
  '@media (min-width: 1024px)': {
    margin: '2rem 0',
  },
  '.filter': {
    '&-list': {
      position: 'absolute',
      top: '100%',
      left: 0,
      width: '100%',
      maxHeight: open ? 1000 : 0,
      overflow: 'hidden',
      transition: `max-height 400ms ease`,
      willChange: 'max-height',
      backfaceVisibility: 'hidden',
      zIndex: 2,
      '@media (min-width: 1024px)': {
        maxHeight: 'none',
        position: 'relative',
        width: 'auto',
        overflow: 'inherit',
      },
    },
    '&-label, &-item .dropdown-label': {
      textTransform: 'uppercase',
      fontSize: '0.75rem',
      fontWeight: 800,
      letterSpacing: '2.5px',
    },
    '&-label':{
      padding: '1rem 0',
      textAlign: 'center',
      display: 'block',
      '@media (min-width: 1024px)': {
        marginRight: '1.5rem',
        padding: 0,
        // display: 'none',
      },
    },
    '&-item': {
      background: dark ? Colors.darkGrey : Colors.extraLightGrey,
      borderBottom: dark ? 0 : `1px solid ${Colors.lightGrey}`,
      maxWidth: '100%',
      flexBasis: '100%',
      color: dark ? 'white' : 'black',
      '@media (min-width: 1024px)': {
        marginRight: '1.5rem',
        background: 'none',
        borderBottom: 0,
        maxWidth: 'none',
        flexBasis: 'auto',
      },
      '.dropdown-label': {
        paddingRight: 20,
      }
    },
    '&-close': {
      position: 'absolute',
      width: 14,
      height: 14,
      top: '50%',
      right: '2rem',
      transform: `translate(0, -50%) rotate(${open ? 0 : -45}deg)`,
      transition: 'transform 300ms ease',
      '&:after, &:before': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100%',
        height: 1,
        background: 'black',
      },
      '&:after': {
        transform: 'translate(-50%, -50%) rotate(-45deg)',
      },
      '&:before': {
        transform: 'translate(-50%, -50%) rotate(45deg)',
      }
    }
  },
})


// WEBPACK FOOTER //
// ./src/styles/components/filter.js